import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { PromotionsTable } from "@/components/promotions/promotions-table"
import { PromotionDialog } from "@/components/promotions/promotion-dialog"
import { PlusIcon } from "lucide-react"

export default function PromotionsPage() {
  const [searchQuery, setSearchQuery] = useState("")
  const [showAddDialog, setShowAddDialog] = useState(false)

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h1 className="text-3xl font-bold">Promotions</h1>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Input
            placeholder="Search promotions..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full sm:w-64"
          />

          <Button onClick={() => setShowAddDialog(true)}>
            <PlusIcon className="h-4 w-4 mr-2" />
            Add Promotion
          </Button>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Promotions List</CardTitle>
        </CardHeader>
        <CardContent>
          <PromotionsTable searchQuery={searchQuery} />
        </CardContent>
      </Card>

      <PromotionDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        promotion={null}
      />
    </div>
  )
}
